import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { pendingJourneysEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-journeys/entrypoint.tsx';

export const journeysPageEntryPoint: ReturnType<typeof createPageEntryPoint> = createPageEntryPoint(
	{
		main: pendingJourneysEntryPoint,
		topNavigationMenuId: MENU_ID.PROJECTS,
	},
);
